import React, { useState, useEffect } from 'react';
import { Grid, Container, Alert, Box } from '@mui/material';
import EventNav from './EventNav';
import CheckoutMap from '@/templates/plus/sections/CheckoutMap';
import useEventContext from '@/contexts/event/useEventContext';
import EventInfo from './EventNav/EventInfo';
import HeaderDesktop from '@/templates/plus/sections/HeaderDesktop';
import CheckoutHomeDesktopLayout from '@/templates/plus/layouts/CheckoutHomeDesktopLayout';
import useAnalyticsEvents from '@/hooks/useAnalyticsEvents';
import useEventStatus from '@/contexts/event/useEventStatus';
import EventEmpty from '@/assets/illustration_EventEmpty';

export default function EventCartDesktop() {
  const { showEventDetails } = useAnalyticsEvents();
  const [view, setView] = useState();
  const [show, setShow] = useState(false);
  const { eventStatus } = useEventStatus();
  const {
    event: {
      event: { use_seats, id },
    },
  } = useEventContext();

  const onCloseEventInfoHandler = () => {
    setView('home');
  };
  const onReadMoreHandler = () => {
    setView('info');
    showEventDetails();
  };
  const onTicketCategorySelectedHandler = () => {
    setView('summary');
  };

  useEffect(() => {
    setShow(true);
  }, []);

  return (
    <>
      <HeaderDesktop showEventInfo={view === 'summary'} />
      <CheckoutHomeDesktopLayout>
        <Grid container spacing={2} sx={{ height: '100%', marginTop: '0px' }}>
          <Grid
            item
            md={use_seats ? 5 : 6}
            sx={{
              height: '100%',
              backgroundColor: '#FFF',
              boxShadow: (theme) => theme.customShadows.side,
              pt: 0,
              overflow: 'hidden',
            }}
          >
            <EventNav
              view={view}
              onCloseEventInfo={onCloseEventInfoHandler}
              onReadMore={onReadMoreHandler}
              onTicketCategorySelected={() => {}}
            />
          </Grid>
          <Grid
            item
            md={use_seats ? 7 : 6}
            sx={{
              width: '100%',
              height: '100%',
              overflow: 'scroll',
            }}
          >
            {show && (
              <>
                {eventStatus === 'active' && (
                  <>
                    <Box
                      sx={{
                        position: 'relative',
                      }}
                    >
                      <Box
                        sx={{
                          position: 'absolute',
                          width: '1px',
                          height: '1px',
                          overflow: 'hidden',
                        }}
                      >
                        <CheckoutMap disabledSaturated onHold={onTicketCategorySelectedHandler} />
                      </Box>
                      <Box
                        sx={{
                          position: 'relative',
                        }}
                      >
                        <Container>
                          <EventInfo />
                        </Container>
                      </Box>
                    </Box>
                  </>
                )}
                {(eventStatus === 'inactive' || eventStatus === 'expired') && (
                  <>
                    <EventEmpty
                      sx={{
                        height: '100%',
                        width: '100%',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                      }}
                    />
                  </>
                )}
              </>
            )}
          </Grid>
        </Grid>
      </CheckoutHomeDesktopLayout>
    </>
  );
}
